import { user } from "@/api";
import VueCookies from "vue-cookies";
import store from "@/store";

export default {
  authenticated: (_to, _from, next) => {
    if (VueCookies.get("access_token")) {
      return next();
    }
    alert("로그인이 필요합니다.");
    return next("/user/login");
  },
  anonymous: (_to, _from, next) => {
    if (!VueCookies.get("access_token")) {
      return next();
    }
    alert("이미 로그인 하였습니다.");
    return next("/");
  },
  savePrevRoute: (_fo, from, next) => {
    store.commit("setPrevRoute", from.fullPath);
    return next();
  },
  isAdmin: async (_to, from, next) => {
    const { data } = await user.getLoginStatus();
    if (data.role === "ADMIN") {
      return next();
    }
    alert("권한이 없습니다.");
    return next(from);
  },
};
